import { createElement } from "react";
import BannerOne from "../../wrappers/banner/BannerOne";
import BlogFeatured from "../../wrappers/blog-featured/BlogFeatured";
import HeroSliderNine from "../../wrappers/hero-slider/HeroSliderNine";
import TabProductFive from "../../wrappers/product/TabProductFive";
import StoryMenu from "../../components/header/PortoMenu";
import CategoryTwoSlider from "../../wrappers/category/CategoryTwoSlider";
import FeatureIcon from "../../wrappers/feature-icon/FeatureIcon";
import BrandLogoSliderThree from "../../wrappers/brand-logo/BrandLogoSliderThree";
import CountDownOne from "../../wrappers/countdown/CountDownOne";
import CountDownThree from "../../wrappers/countdown/CountDownThree";
import TestimonialOne from "../../wrappers/testimonial/TestimonialOne";
import FunFactOne from "../../wrappers/fun-fact/FunFactOne";
import PortoBlock from "../../components/product/PortoBlock";
import HeroSliderNineteen from "../../wrappers/hero-slider/HeroSliderNineteen";
import HeroSliderEight from "../../wrappers/hero-slider/HeroSliderEight";
import TabProductCategory from "../../wrappers/product/TabProductCategory";
import TabProductCategorySingle from "../../wrappers/product/TabProductCategorySingle";
import HeroSliderFive from "../../wrappers/hero-slider/HeroSliderFive";
import RawHTML from "./CustomHtml";
import Lightbulb from "../other/Lighbulb";

const Components = {
    bannerOne: BannerOne,
    blogFeatured: BlogFeatured,
    heroSliderNine: HeroSliderNine,
    tabProductFive: TabProductFive,
    storyMenu: StoryMenu,
    categoryTwoSlider: CategoryTwoSlider,
    featuredIcon: FeatureIcon,
    brandLogoSliderThree: BrandLogoSliderThree,
    countDownOne: CountDownThree,
    testimonialOne: TestimonialOne,
    funFactOne: FunFactOne,
    advertComponent: PortoBlock,
    categoryTabs: TabProductCategory,
    categorySingle: TabProductCategorySingle,
    heroSliderFive: HeroSliderFive,
    customHtml: RawHTML,
    htmlEditor: RawHTML,
    lightBulb: Lightbulb

};
export default (block) => {
  if (typeof Components[block.component] !== "undefined") {
    return createElement(Components[block.component], {
      key: block._uid,
      block: block
    });
  }
  return createElement(
    () => null,
    { key: block._uid }
  );
};
